import React, { Component,useEffect, useRef, useCallback } from 'react'

import Webcam from "react-webcam";
//  const webcamRef = useRef(null);
 //const [url, setUrl] = React.useState(null);

//const webcamRef = useRef<Webcam>(null);

const webcam = useRef<Webcam>(null);
const videoConstraints = {
    width: 540,
    facingMode: "environment"
  };
  

  

export default class Webcameras extends Component {




    constructor(props) {
        super(props);
        this.state = {
        modal: false,
        loading:false,
        url:null,
        img:null,
        files:null,
        }

        // this.capturePhoto = this.capturePhoto.bind(this);
        // this.onUserMedia = this.onUserMedia.bind(this);
       
    }

  render() {

       const Camera = () => {
        const webcamRef = useRef(null);
        const [url, setUrl] = React.useState(null);
      
        const capturePhoto = React.useCallback(async () => {
          const imageSrc = webcamRef.current.getScreenshot();
          setUrl(imageSrc);
          this.setState({
            url: imageSrc,
          });
         // console.log(imageSrc);
        }, [webcamRef]);
      
        const onUserMedia = (e) => {
          console.log(e);
        };
      
    
        return (
          <>
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              onUserMedia={onUserMedia}
            />
            <button onClick={capturePhoto}>Capture</button>
            <button onClick={() => setUrl(null)}>Refresh</button>
            {url && (
              <div>
                <img src={url} alt="Screenshot" />
              </div>
            )}
          </>
        );
      };

    return (
      <div>   
       <Camera />
      {this.state.url}
    </div>
    )
  }
}

